import { useContextState } from '../../../../../hooks/theme'

export const useStyles = () => {
  const { colors } = useContextState()

  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      padding: '8px 2px',
      overflowY: 'auto',
      minHeight: 0,
    },
    title: {
      fontSize: '18px',
      fontWeight: '600',
      color: colors.color9,
    },
    subtitle: {
      fontSize: '14px',
      color: colors.color10,
    },
    section: {
      display: 'flex',
      flexDirection: 'column',
      marginTop: '24px',
    },
    sectionTitle: {
      fontSize: '16px',
      fontWeight: '600',
      color: colors.color13,
    },
    sectionHelper: {
      fontSize: '14px',
      color: colors.color10,
    },
    selectContainer: {
      width: '30%',
      minWidth: '280px',
      marginTop: '12px',
    },
    emailsContainer: {
      marginTop: '12px',
    },
  }
}
